import { defaultRangePreset, rangePresets } from '@gogame/intl-ts';
import { array, string } from '@gogame/schemas';

export const periodSchema = array(string())
  .constants(defaultRangePreset)
  .default(rangePresets.LAST_30_DAYS.value);
